import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, StyleSheet } from 'react-native'

export const EnterManually: React.FC = () => {
  const { t } = useTranslation('global')
  return (
    <Text style={styles.enterManuallyText}>
      {t('ProjectForm.please-enter-manually')}
    </Text>
  )
}

const styles = StyleSheet.create({
  enterManuallyText: {
    fontWeight: '400',
    fontSize: 12,
    color: 'rgba(17, 17, 19, 0.6)',
    marginTop: 7,
  },
})
